import { getSlaugherhouseSpecificSheepBuySellKinds } from 'src/slaughterhouseSpecific';

export const maxCharactersCommentAnimal = 144;
export const maxCharactersCommentWhole = 101;

export const maxCharactersReturnMeatPickupLocation = 100;
export const maxLengthHealthRemarksComment = 200;

export const cattleKindsSlaughter = ['Kalv', 'Okse', 'Kvige', 'Ku'];
export const cattleKindsSell = ['Oksekalv', 'Kvigekalv', 'Okse', 'Kvige', 'Ku'];

export const sheepKinds = ['Sau', 'Lam', 'Vær', 'Geit', 'Kje'];
export const pigKinds = ['Gris', 'Vak gris', 'Purke', 'Råne'];

export const pigBuySellKinds = ['Smågris', 'Smågris Vak', 'Smågris SPF'];

// if this names is to be changed, also remember to change them on the backend since these names are used to identify
export const sheepBuySellKinds = [
  'Dala',
  'Rygja',
  'Kvit spælsau',
  'Suffolk',
  'Norsk kvit sau',
  'Norsk pelssau',
  'Gammelnorsk sau',
  'Gammalnorsk spælsau',
  'Blæset',
  'Farga spælsau',
  'Annen, se kommentar',
].concat(getSlaugherhouseSpecificSheepBuySellKinds());

export const healthRemarks = [
  { text: 'Svak halthet', id: 'SVAK_HALTHET' },
  { text: 'Bogsår', id: 'BOGSAAR' },
  { text: 'Halesår med skorpe', id: 'HALESAAR_MED_SKORPE' },
  { text: 'Brokk', id: 'BROKK' },
  { text: 'Behandlet framfall/prolaps', id: 'BEHANDLET_PROLAPS' },
  { text: 'Gjensittende sting etter operasjon', id: 'GJENSITTENDE_STING' },
  { text: 'Delvis avstøtt jur', id: 'DELVIS_AVSTOETT_JUR' },
  { text: 'Gamle bruddskader', id: 'GAMLE_BRUDDSKADER' },
  { text: 'Medfødt skavank', id: 'MEDFOEDT_SKAVANK' },
  { text: 'Helt eller delvis blind', id: 'HELT_DELVIS_BLIND' },
  { text: 'Vom i skinn', id: 'VOM_I_SKINN' },
  { text: 'Annet (spesifiser i kommentar)', id: 'ANNET' },
];
export const healthRemarksIdsRequiresComment = ['ANNET'];

export const buySellSheepAgeCategoryValues = ['lamb', 'sheep', 'vaer'];
export const buySellSheepAgeCategoryKinds = ['Lam', 'Sau', 'Vær'];
